import { FormattedMessage } from 'react-intl';

interface Props {
  headingId: string;
  descriptionId?: string;
}

export default function AuthFormHeading({ headingId, descriptionId }: Props) {
  return (
    <div className="space-y-2">
      <h1 className="text-3xl font-semibold tracking-tight text-slate-900">
        <FormattedMessage id={headingId} />
      </h1>
      {descriptionId && <p className="text-sm leading-6 text-slate-600"><FormattedMessage id={descriptionId} /></p>}
    </div>
  );
}
